import React from "react";
import styled from "styled-components";
import useProductInfos from "../useProductInfos";
import categories from "../categories.json";

const ProductDataList = () => {
  const { productData } = useProductInfos();

  let prevCategory = null;

  return productData.map((inp) => {
    const category = categories.find((c) => inp.key.includes(c.prefix));

    const component = (
      <>
        {prevCategory !== category && category && (
          <h4 className="badge border badge-dark  my-0">{category.name}</h4>
        )}
        <StyledRow
          className="d-flex w-100 align-items-md-center py-3 flex-column flex-md-row"
          key={`pdl${inp.id}`}
        >
          <StyledLabel className="font-weight-bold d-flex align-items-center position-relative">
            <i className="fa fa-dot-circle mr-2 text-primary" />{" "}
            <span> {inp.label || inp.id}</span>
          </StyledLabel>
          <StyledValue className="text-primary font-weight-bold">
            {inp.realValue}
          </StyledValue>
        </StyledRow>
      </>
    );
    if (prevCategory !== category) {
      prevCategory = category;
    }

    return component;
  });
};

const StyledRow = styled.div`
  gap: 8px;
  &:hover {
    background: var(--color-default-light);
  }
`;

const StyledLabel = styled.div`
  line-height: 20px;
  width: 100%;
  @media (min-width: 768px) {
    width: 50%;
    min-width: 50%;
    flex-shrink: 0;
  }
`;

const StyledValue = styled.div`
  line-height: 20px;
  width: 100%;
  @media (min-width: 768px) {
    width: 50%;
  }
`;

export default ProductDataList;
